(() => {
  angular
    .module('complianceFrameworkApp.core')
    .filter('normalizeStatusCustomer', normalizeStatusCustomer);

  function normalizeStatusCustomer() {
    return input => {
      if (input != null) {
        switch (input) {
        case 'open':
          return 'Sent';
        case 'in_progress':
          return 'In Progress';
        case 'draft':
          return 'In Progress';
        case 'closed':
          return 'Answered';        
        case 'follow_up': 
          return 'Follow Up';
        }
      }
    };
  }
})();
